import React, { useEffect, useState } from 'react'
import ModalWrapper from '../../../../../../Components/CustomModal/ModalWrapper'
import { Dropdown } from 'primereact/dropdown';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import { V_URL } from '../../../../../../BaseUrl';
import toast from 'react-hot-toast';
import { getViewPrItems } from '../../../../../../Store/prosafe/proTransaction/PurRequest/getViewPrItems';
import ItemDropdownWithAddButton from './ItemDropdownWithAddButton';

const ManualPrModel = ({ modal, itemsArr, editingIndex, setEditingIndex, onSubmit, data, editItemId, setEditItemId }) => {

  const partyData = useSelector((state) => state.getParty?.user?.data) || [];
  const itemData = useSelector((state) => state.getItem?.user?.data) || [];
  const [errors, setErrors] = useState({});
  const dispatch = useDispatch();

  const initialFormState = {
    item_id: '',
    item_no: '',
    required_qty: '',
    item_length: '',
    item_width: '',
    item_weight: '',
    item_radius: '',
    item_thickness: '',
    discount: "",
    discount_amount: "",
    taxable_amount: '',
    unit: '',
    category: '',
    assembly_weight: '',
    assembly_surface_area: '',
    rate: '',
    mrp: '',
    amount: '',
    gst: '',
    gst_amount: '',
    total_amount: '',
    pr_party: '',
    remarks: '',
    isAuto: false,
  };
  const [disable, setDisable] = useState(false);
  const [formData, setFormData] = useState(initialFormState);

  useEffect(() => {
    if (editingIndex !== null && itemsArr[editingIndex]) {
      setFormData(itemsArr[editingIndex]);
    } else {
      setFormData(initialFormState);
    }
  }, [editingIndex, itemsArr]);

  useEffect(() => {
    if (formData.item_id) {
      const selectedItem = itemData.find((item) => item._id === formData.item_id);
      if (selectedItem) {
        setFormData((prev) => ({
          ...prev,
          // item_thickness: selectedItem?.thickness || '',
          unit: selectedItem?.unit?.name || '',
          category: selectedItem?.category?.name || '',
          gst: selectedItem?.gst_percentage || '',
        }));
      }
    }
  }, [formData.item_id, itemData]);

  useEffect(() => {
    if (!modal.isShown) {
      setFormData(initialFormState);
      setEditingIndex(null);
      setEditItemId(null);
      setErrors({});
    }
  }, [modal.isShown]);

  useEffect(() => {

    const qty = parseFloat(formData.required_qty) || 0;
    const rate = parseFloat(formData.rate) || 0;
    const gst = parseFloat(formData.gst) || 0;
    const discount = parseFloat(formData.discount) || 0;

    const amount = qty * rate;
    const discount_amount = (amount * discount) / 100;
    const taxable_amount = amount - discount_amount;
    const gst_amount = (taxable_amount * gst) / 100;
    const total_amount = taxable_amount + gst_amount;

    setFormData((prev) => ({
      ...prev,
      amount: amount.toFixed(2),
      discount_amount: discount_amount.toFixed(2),
      taxable_amount: taxable_amount.toFixed(2),
      gst_amount: gst_amount.toFixed(2),
      total_amount: total_amount.toFixed(2),
    }));
  }, [formData.required_qty, formData.rate, formData.gst, formData.discount]);

  const validateForm = () => {
    const newErrors = {};
    if (!formData.item_id) newErrors.item_id = 'Item is required';
    if (!formData.required_qty || parseFloat(formData.required_qty) <= 0)
      newErrors.required_qty = 'Valid quantity is required';
    // if (formData.rate === '' || parseFloat(formData.rate) < 0)
    //   newErrors.rate = 'Valid rate is required';
    // if (!formData.pr_party) newErrors.pr_party = 'Party is required';
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));

    if (errors[name]) {
      setErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[name];
        return newErrors;
      });
    }
  };

  const handleDropdownChange = (name, value) => {
    setFormData((prev) => ({ ...prev, [name]: value }));

    if (errors[name]) {
      setErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[name];
        return newErrors;
      });
    }
  };

  const handleFormAction = async (e, isAddMore = false) => {
    e.preventDefault();
    if (!validateForm()) return;

    setDisable(true);
    try {
      if (editItemId) {
        const payload = {
          id: data._id,
          item_detail_id: editItemId,
          items_details: {
            pr_party: formData.pr_party ? formData.pr_party : null,
            required_qty: formData.required_qty,
            // item_length: formData.item_length,
            // item_width: formData.item_width,
            item_weight: formData.item_weight,
            // item_radius: formData.item_radius,
            // item_thickness: formData.item_thickness,
            // assembly_weight: formData.assembly_weight,
            // assembly_surface_area: formData.assembly_surface_area,
            discount: formData.discount,
            discount_amount: formData.discount_amount,
            taxable_amount: formData.taxable_amount,
            rate: formData.rate,
            mrp: formData.mrp,
            amount: formData.amount,
            gst: formData.gst,
            gst_amount: formData.gst_amount,
            total_amount: formData.total_amount,
            remarks: formData.remarks,
          },
        };
        const resp = await axios.put(`${V_URL}/prosafe/pro-update-pr-item`, payload, {
          headers: { Authorization: `Bearer ${localStorage.getItem('PAY_USER_TOKEN')}` },
        });
        if (resp.data.success) {
          toast.success(resp.data.message);
          dispatch(getViewPrItems({ formData: { id: data._id } }));
          if (isAddMore) {
            setFormData(initialFormState);
            setEditingIndex(null);
            setEditItemId(null);
            setErrors({});
          } else {
            modal.hide();
            setEditingIndex(null);
            setEditItemId(null);
          }
        } else {
          toast.error(resp.data.message);
        }
      } else if (data?._id) {
        const payload = {
          id: data._id,
          items_details: [{ ...formData, pr_party: formData.pr_party ? formData.pr_party : null, balance_qty: formData.required_qty }],
        };
        const resp = await axios.post(`${V_URL}/prosafe/pro-add-pr-item`, payload, {
          headers: { Authorization: `Bearer ${localStorage.getItem('PAY_USER_TOKEN')}` },
        });
        if (resp.data.success) {
          toast.success(resp.data.message);
          dispatch(getViewPrItems({ formData: { id: data._id } }));
          if (isAddMore) {
            setFormData(initialFormState);
            setEditingIndex(null);
            setEditItemId(null);
            setErrors({});
          } else {
            modal.hide();
          }
        } else {
          toast.error(resp.data.message);
        }
      } else {
        onSubmit(formData);
        if (isAddMore) {
          setFormData(initialFormState);
          setEditingIndex(null);
          setEditItemId(null);
          setErrors({});
        } else {
          modal.hide();
        }
      }
    } catch (error) {
      console.error(error);
      toast.error(error?.response?.data?.message || 'Something went wrong');
    } finally {
      setDisable(false);
    }
  };

  return (
    <ModalWrapper
      title="Manual Items Details"
      isShown={modal.isShown}
      hide={modal.hide}
      footer={false}
      customSize={"modal-90w"}
    >
      <form>
        <div className='row'>
          <div className="col-lg-4 col-md-6 col-12">
            <div className="input-block local-forms custom-dropdown">
              {/* PARTY VALIDATION IS REMOVED BECAUSE (BELIEVE CLIENT) DON'T ADDED PARTY IN PR TIME DISCUSSED WITH NIRAV SIR 18-03-2026 */}
              <label>Party</label>
              <Dropdown
                value={formData.pr_party}
                options={partyData.map(e => ({ label: e.name, value: e._id }))}
                onChange={(e) => handleDropdownChange('pr_party', e.value)}
                placeholder="Select Party"
                filter
                enforceFocus={false}
                appendTo="self"
                className={`w-100 ${errors.pr_party ? 'p-invalid' : ''}`}
              />
              {errors.pr_party && <small className="p-error">{errors.pr_party}</small>}
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-4 col-md-6 col-12">
            <ItemDropdownWithAddButton
              value={formData.item_id}
              onChange={(value) => handleDropdownChange('item_id', value)}
              itemData={itemData}
              disabled={editingIndex !== null || !!editItemId}
              error={errors.item_id}
              label="Item Name"
              required={true}
            />
          </div>
          {formData.item_id && (
            <>
              <div className="col-lg-4 col-md-6 col-12">
                <div className="input-block local-forms">
                  <label>Unit</label>
                  <input type="text" className="form-control" value={formData.unit} disabled />
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-12">
                <div className="input-block local-forms">
                  <label>Category</label>
                  <input type="text" className="form-control" value={formData.category} disabled />
                </div>
              </div>
            </>
          )}

          {[
            // { name: 'item_no', label: 'Item No', type: 'text' },
            { name: 'required_qty', label: 'Required Quantity', required: true, type: 'number' },
            // { name: 'item_length', label: 'Length', type: 'number' },
            // { name: 'item_width', label: 'Width', type: 'number' },
            // { name: 'item_weight', label: 'Weight', type: 'number' },
            // { name: 'item_radius', label: 'Radius', type: 'number' },
            // { name: 'item_thickness', label: 'Thickness', type: 'text' },
            // { name: 'assembly_weight', label: 'Assembly Weight', type: 'number' },
            // { name: 'assembly_surface_area', label: 'Surface Area', type: 'number' },
            { name: 'mrp', label: 'Original Rate(₹)', type: 'number' },
            { name: 'rate', label: 'Purchase Rate(₹)', required: false, type: 'number' },
            { name: 'discount', label: 'Discount', type: 'number' },
            { name: 'amount', label: 'Amount(₹)', type: 'number', disabled: true },
            { name: 'discount_amount', label: 'Discount Amount', type: 'number', disabled: true },
            { name: 'taxable_amount', label: 'Taxable Amount', type: 'number', disabled: true },
            { name: 'gst', label: 'GST(%)', type: 'number' },
            { name: 'gst_amount', label: 'GST Amount(₹)', type: 'number', disabled: true },
            { name: 'total_amount', label: 'Total Amount(₹)', type: 'number', disabled: true },
            { name: 'remarks', label: 'Remarks', type: 'text' }
          ].map(({ name, label, required, type, disabled }) => (
            <div key={name} className="col-lg-4 col-md-6 col-12">
              <div className="input-block local-forms">
                <label>
                  {label} {required && <span className="login-danger">*</span>}
                </label>
                <input
                  type={type || 'text'}
                  className={`form-control ${errors[name] ? 'is-invalid' : ''}`}
                  name={name}
                  value={formData[name]}
                  onChange={handleChange}
                  disabled={disabled || false}
                />
                {errors[name] && <div className="invalid-feedback">{errors[name]}</div>}
              </div>
            </div>
          ))}
        </div>

        <div className="col-12 text-end">
          <div className="text-end">
            <button type="button" className="btn btn-primary" disabled={disable} onClick={(e) => handleFormAction(e, false)}>
              {editingIndex !== null ? 'Update' : 'Submit'}
            </button>
            {editingIndex === null && (
              <button type="button" className="btn btn-outline-primary m-2" onClick={(e) => handleFormAction(e, true)}>
                Add More
              </button>
            )}
          </div>
        </div>
      </form>
    </ModalWrapper>
  )
}

export default ManualPrModel